<!--
 * @Author: yuanjianlong
 * @Description: 用户协议
 * @Date: 2021-12-09 14:41:22
 * @LastEditTime: 2021-12-27 16:18:38
 * @FilePath: /teacher-h5/src/components/UserProtocol.vue
-->
<template>
  <a-modal
    :visible="visible"
    title="爱学习用户服务协议"
    width="796px"
    :footer="null"
    centered
    wrap-class-name="protocol-modal"
    @cancel="handleCancel"
  >
    <div class="modal-body-main">
      <p style=" margin:0pt">
        <span>&nbsp;</span><span>&nbsp;&nbsp; </span>
      </p>
      <p style="text-align:right;font-weight: normal;line-height: 1.5;">
        <span>发布日期：</span><span>2021</span><span>年</span><span>8</span><span>月25日</span>
      </p>
      <p style="text-align:right;font-weight: normal;line-height: 1.5;">
        <span>生效日期：2</span><span>021</span><span>年</span><span>8</span><span>月25日</span>
      </p>
      <p style=" margin:0pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt; font-weight: normal;line-height: 1.5;margin-bottom: 24px;">
        <span>欢迎使用北京爱学习博乐教育科技有限公司[根据实际运营主体调整]（以下简称“爱学习”）提供的线上产品和／或服务！</span>
      </p>
      <p style=" margin:0pt; text-indent:21pt">
        <span>本《爱学习用户服务协议》（下称“本协议”）是您与爱学习之间就爱学习通过爱学习平台（包括但不限于爱学习所有、合法运营或授权运营的</span><a name="_Hlk65587471" /><a name="_Hlk65656072"><span>官方网站、移动应用、电脑客户端</span><span style="-aw-bookmark-end:_Hlk65587471" /><span>、相关微信开放平台账号或小程序、Ｈ５链接等</span></a><span>，以下合称“爱学习平台”，分称“爱学习各平台”）所提供的产品和／或服务等相关事宜所订立的协议，除非您与爱学习之间就爱学习产品和／或服务的使用达成了其他协议和约定，否则您对爱学习产品和／或服务的使用均受本协议的约束。您通过爱学习产品和／或服务而接入的第三方产品和／或服务，不适用本协议规定，您应在使用该等第三方提供的产品和／或服务时，遵从您与该等第三方签署的各项协议及约定。</span>
      </p>
      <p style=" margin:0pt; text-indent:21pt">
        <span>您理解您将通过在爱学习平台点击确认的形式（包括但不限于勾选“确认”、“同意”或表示同意签署本协议的其他类似选项，点击“确认”、“同意”、“登录”或表示同意签署本协议的其他类似按钮，以及作出其他与前述行为类似的行为）签署本协议，请您务必在点击同意本协议之前，审慎阅读、充分理解各条款内容，特别是免除或者限制爱学习责任的条款、法律适用和争议解决条款。免除或者限制爱学习责任的条款将以粗体标识，您应重点阅读。一经您在爱学习平台上进行点击确认的操作，即视为您已全面、细致、充分阅读、理解且接受本协议的全部内容，并与爱学习达成一致，本协议对您及爱学习均具有法律约束力。</span>
      </p>
      <p style=" margin:0pt; text-indent:21pt">
        <span>在您同意并接受本协议全部条款的前提下，爱学习授予您合法使用爱学习产品和／或服务的权利。</span>
      </p>
      <p style=" margin:0pt; text-indent:21pt">
        <span>如果您是未成年人，则请您在法定监护人陪同下审阅和判断是否同意本协议，未成年人使用爱学习产品和／或服务的行为将被视为</span><a name="_Hlk65598387"><span>已获得了法定监护人的认可和同意</span></a><span>。如果您不同意接受本协议的全部条款，则您无权注册、登录或使用本协议所涉及的产品和／或服务，您下载、安装、使用爱学习产品和／或服务的行为，将被视为您自愿遵守本协议及爱学习的其他有关规则，并完全服从于爱学习的统一管理。</span>
      </p>
      <p style=" margin:0pt; text-indent:21pt">
        <span>爱学习有权根据业务需要不定时对本协议进行调整，并将调整后的协议以适当的可以为您所知的方式进行公布（包括但不限于公布在官方网站、移动应用、电脑客户端等平台上），如果您不同意调整后的本协议的，您应当停止使用爱学习产品和／或服务；如果在爱学习调整本协议并公布后，您继续使用爱学习产品和／或服务的，则视为您同意遵守调整后的协议。</span>
      </p>
      <p style=" margin:0pt; text-indent:21pt">
        <span>如您对本协议有任何疑问，可按照本协议文末列明的方式与我们取得联系。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <ol type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:微软雅黑; font-weight:bold;  margin:0pt 0pt 0pt 14.47pt; padding-left:6.53pt; text-indent:0pt">
          <span>用户资格授予</span>
        </li>
      </ol>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>1.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">除非另有说明或法律法规另有规定，爱学习平台及平台内容（含产品及服务）的所有权、运作权、知识产权等任何合法权益均归爱学习所有。您同意本协议条款并完成账号注册或登录的，即成为爱学习产品和／或服务的正式用户，爱学习授予您合法使用爱学习产品和／或服务的权利。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>1.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您同意本协议的，即视为您确认自己具有享受爱学习产品和／或服务的相应民事权利能力和民事行为能力，能够独立承担法律责任。</span><span>未成年人同意本协议的，即视为已获得了法定监护人的认可和同意，并愿意承担相关法律后果。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <ol start="2" type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:微软雅黑; font-weight:bold;  margin:0pt 0pt 0pt 14.47pt; padding-left:6.53pt; text-indent:0pt">
          <span>您的权利与义务</span>
        </li>
      </ol>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您通过爱学习平台或爱学习合法授权的渠道下载、安装并使用爱学习产品，是您获得爱学习产品和／或服务使用授权的前提。如果您从非爱学习平台或非爱学习合法授权的渠道获取并使用与爱学习平台、爱学习产品和／或服务、爱学习软件等名称相同或近似的程序，爱学习无法保证该等程序的合法性和可用性，并且不对您使用该等程序遭受的损失或给他人造成的损失负责。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>您一经在爱学习平台进行注册或登录，即视为您同意爱学习及／或其关联公司（含爱学习及／或其关联公司的工作人员）可以与您进行电话联系以及向您发送手机短信。</span>
      </p>
      <p style="margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您在爱学习平台注册成功后，将产生用户名和密码等账号信息，您可以根据爱学习平台规则或客服人员指导自行操作修改密码。</span><span>您应确保您的账号长期处于活跃状态，如您长时间未登录或使用账号，您的账号可能被收回。</span><span style="font-family:微软雅黑; font-weight:normal">您在爱学习平台注册的账号所有权归爱学习所有，您仅有该账号的使用权。</span><span>您应谨慎合理的使用、保管您的用户名和密码，不得有出租、转让、出借、出售、共享等行为，否则爱学习有权在发现相关行为后对该账号采取处罚措施</span><a name="_Hlk65591000"><span>（包括但不限于拒绝提供产品及服务、限制使用权限、取消订单或交易、暂时封停及永久查封账号等）</span></a><span>。</span><span style="font-family:微软雅黑; font-weight:normal">任何时候爱学习均不会主动要求用户提供其账号密码。因此，建议您务必保管好您的账号，并确保您在每个上网时段结束时退出登录并以正确步骤离开爱学习平台。您应当对通过您账号所为的一切活动负责。您若发现您的账号被盗用、冒用或被以其他任何形式非法使用，应立即通知爱学习，爱学习将在收到有关通知后尽快采取措施予以补救，但爱学习不保证补救措施的效果，也不对您或其他任何第三方因此遭受的损失承担责任。对于因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，您应通过司法、行政等救济途径向侵权行为人主张权利。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您通过爱学习平台享有的服务由爱学习根据实际情况提供，该等服务内容并非最终、确定的，爱学习有权不时进行增加、删除、修改或进行其他形式的调整，您在使用相关服务时，应当仔细阅读、全面了解服务内容及使用规则。一旦爱学习的服务内容发生调整，爱学习将在相关页面上进行提示；如果您不同意相关调整，可以取消已经获取的服务并停止使用；如果您继续使用爱学习提供的服务，则视为您已经接受全部调整。除非另有明确约定，否则您使用爱学习调整、新增的服务内容将同样受本协议各项条款的约束。您理解并同意，基于业务侧重点不同，爱学习各平台展示和提供的产品和／或服务可能有所区别，除非另有约定或另有说明，否则您使用爱学习各平台产品和／或服务仍受本协议约束。爱学习平台提供的服务包括但不限于：</span><a name="_Hlk65671656" />
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>班级管理：您可以通过爱学习平台查看您名下的班级信息，并可查看各班级所有学员的基本信息；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>备课及备课管理：您可以通过爱学习平台进行备课，并对已备课课程进行管理；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>教学内容填充：您可以通过爱学习平台创建及填充新的教学内容，并对新创建的教学内容进行排序、删除、切换等操作；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>课程内容编辑：您可以对课程内容进行增删知识点、标记题目、调整知识点顺序等操作；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>课程内容播放：您可以通过爱学习平台播放已完成备课的课程内容；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4.6</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>投屏：您可以将教学内容投放在幕布上进行授课；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4.7</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>题目推送：您可以向学员推送与所授知识点相同或类似的题目、考题；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4.8</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>监课：您可以查看学员的登录状态及做题状态；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.4.9</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>学情管理：您可以查看学员的答题情况及学习情况相关数据；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 49.65pt; text-indent:-28.65pt">
        <span>2.4.10</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>客服服务：在使用爱学习提供的产品和／或服务过程中，如果您有任何疑问、意见、建议，</span><a name="_Hlk65605523"><span>或打算进行举报、投诉，</span></a><span>则可以与爱学习客服进行联系；</span><span style="-aw-bookmark-end:_Hlk65671656" />
      </p>
      <p style=" margin:0pt 0pt 0pt 49.65pt; text-indent:-28.65pt">
        <span>2.4.11</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>其他爱学习平台上已发布的或爱学习平台不时发布、调整的服务内容。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您在使用爱学习提供的产品和／或服务时，必须自行准备如下设备和承担如下开支：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.5.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>上网设备，包括并不限于电脑、手机、平板电脑或者其他移动、智能终端设备；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.5.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.6</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>爱学习提供的产品和／或服务分为有偿和无偿两种形式。对于现阶段无偿提供的产品和／或服务，爱学习有权随时根据内部政策的调整将其变更为有偿服务，如果发生该等变更的，爱学习将提前告知您，如果您不同意的，可以停止使用相应的产品和／或服务。对于有偿提供的产品和／或服务，爱学习有权自行确定该等产品和／或服务的价格并不时调整，调整后的价格将在爱学习平台中进行公示，如果您不同意调整后的价格的，则您可以在您原购买的有偿产品和／或服务</span><span>到期后停止付费购买该产品和／或服务。如果您在爱学习调整价格并公示后，仍继续购买收费产品和／或服务的，则视为您同意该调整后的价格。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.7</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">爱学习可能根据业务发展需要、市场环境变化等因素，不时发布优惠政策或开展优惠活动，该等优惠政策或优惠活动以爱学习平台上的实时信息为准。您知悉并认可，爱学习有权自行决定是否提供优惠政策或开展优惠活动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或终止。如果爱学习开展的优惠活动包含优惠券或折扣等优惠方式，且您通过合法方式获得了相关优惠券或折扣的，则您知悉并认可，该等优惠券或折扣必须满足一定条件才能使用，具体以该优惠券上的信息提示和优惠券使用说明、或爱学习公示的折扣使用说明为准。</span><span>优惠券或折扣不兑现（即不直接兑换现金）、不找零（即订单金额不足抵用券金额的，抵用券剩余金额无效）、过期作废；优惠券或折扣仅限同一用户账号使用，严禁出售、转让或共享。如爱学习发现存在出售、转让或共享优惠券或折扣等情形的，该优惠券或折扣将予以作废处理，且爱学习有权视情节严重程度对相关用户采取处罚措施（包括但不限于拒绝提供产品及服务、限制使用权限、取消订单或交易、暂时封停及永久查封账号等），并保留追究相关责任人法律责任的权利。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.8</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您必须遵守中华人民共和国的法律、法规、规章、条例，以及其他具有法律效力的规范，不得将爱学习提供的产品和／或服务用于非法用途。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.9</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您不得干扰或混乱网络服务。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.10</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span style="font-family:微软雅黑; font-weight:normal">您不得侵犯爱学习对其产品和／或服务合法享有的所有权、知识产权等任何权益。也不得在使用爱学习产品和／或服务过程中，侵犯其他任何第三方的合法权益。</span><span>爱学习不对您在使用爱学习产品和／或服务过程中侵犯其他第三方合法权益的行为负责，您应当自行负责解决相关的侵权纠纷，并承担最终、全部责任。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您不得在使用爱学习产品和／或服务过程中发布非法信息，您对通过您账号发布的内容承担最终、全部责任。</span><span style="font-family:微软雅黑; font-weight:normal">上述非法信息包括：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>反对宪法所确定的基本原则的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>损害国家荣誉和利益的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>煽动民族仇恨、民族歧视、破坏民族团结的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.6</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>散布谣言，扰乱社会秩序，破坏社会稳定的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.7</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.8</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>侮辱或者诽谤他人，侵害他人合法权利的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.9</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.10</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span><span>以非法民间组织名义活动的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.11</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span><span>含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.12</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span><span>含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.13</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span><span>发表含有猥亵、人身攻击和反政府言论等非法或侵权言论的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.14</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span><span>从事非法商业活动；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.11.15</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp; </span><span>其他爱学习认为违反法律法规规定的情况。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.12</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您不得利用I</span><span>D</span><span>捕获爱学习提供的产品和／或服务用以制作、上载、复制、发布、传播如下干扰爱学习平台及其软件正常运营，以及侵犯其他用户或第三方合法权益的内容：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.12.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>含有任何性或性暗示的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.12.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>含有辱骂、恐吓、威胁内容的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.12.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>含有骚扰、垃圾广告、恶意信息、诱骗信息的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.12.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>涉及他人隐私、个人信息或资料的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.12.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>侵害他人一般人格权、名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.12.6</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span>含有其他干扰爱学习平台及其软件正常运营和侵犯其他用户或第三方合法权益内容的信息。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.13</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您不得为任何非法目的而使用爱学习平台及其软件，不得利用爱学习平台及其软件从事以下活动：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.13.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">未经允许，进入计算机信息网络或者使用计算机信息网络资源；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.13.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">未经允许，对计算机信息网络功能进行删除、修改或增加；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.13.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.13.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">故意制作、传播计算机病毒等破坏性程序；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.13.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">其他危害计算机网络安全的行为。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.14</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您不得利用爱学习平台及其软件从事如下行为：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.14.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.14.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">强制、诱导其他用户关注、点击链接页面或分享信息；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.14.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">虚构事实、隐瞒真相以误导、欺骗他人；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.14.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.14.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">未经爱学习书面同意即利用爱学习账号和任何功能进行推广或相互推广；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.14.6</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">利用技术手段批量建立虚假账号；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.14.7</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.14.8</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">其他违反法律法规规定、侵犯其他用户合法权益、干扰爱学习平台及其软件正常运营的行为。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>爱学习有对用户账号昵称进行审核的权利，凡用户昵称中出现如下信息的（包括但不限于），爱学习有权进行屏蔽、锁定，甚至强制注销：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">使用严重违反国家法律法规、公序良俗，包含或暗藏反动、色情等信息（含符号、地址等）的昵称；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">使用党和国家领导人、古今中外比较有影响的名人、网络上知名人士的真实姓名、字、号、艺名、笔名、头衔等为昵称；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">使用国家机构、企事业单位、知名公司或品牌的名称及标识为昵称；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">含性别歧视、种族歧视、地域歧视等信息的昵称；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">含侮辱、猥亵或者对他人进行侮辱、挑衅、谩骂、人身攻击等不文明、不健康信息的昵称；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15.6</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">含易产生歧义、引起他人误解的信息的昵称；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15.7</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">未获得爱学习官方正式书面许可而使用带有“爱学习”“高思”及其他与爱学习及其关联公司名称、字号、商标、标识等相同或类似的昵称；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15.8</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">带有明显广告性质的昵称；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.15.9</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">带有其他法律法规以及爱学习禁止规则中所包含信息的昵称。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.16</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span style="font-family:微软雅黑; font-weight:normal">爱学习保留删除平台内各类违反法律法规、监管政策、爱学习平台规则及违背社会公序良俗等非法内容、信息而无须通知用户的权利。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.17</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span style="font-family:微软雅黑; font-weight:normal">若您有任何违反本协议约定的行为，爱学习有权视情节严重程度做出独立判断并对您采取您处罚措施（包括但不限于拒绝提供产品及服务、限制使用权限、清除或编辑内容、取消订单或交易、暂时封停及永久查封账号等）。您须对自己在网上的言论和行为承担法律责任。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>2.18</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span style="font-family:微软雅黑; font-weight:normal">您不得利用爱学习产品和／或服务从事任何非法获利活动（包括但不限于采取利用程序漏洞、恶意攻击服务器等形式），对于您非法获得的利益，爱学习有权没收或清除，并保留追究您法律责任的权利。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:21pt">
        <span>&nbsp;</span>
      </p>
      <ol start="3" type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:微软雅黑; font-weight:bold;  margin:0pt 0pt 0pt 14.47pt; padding-left:6.53pt; text-indent:0pt">
          <span>平台管理</span>
        </li>
      </ol>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>3.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">爱学习保留在中华人民共和国大陆地区法律允许的范围内独自决定拒绝提供服务、限制用户使用权限、清除或编辑内容、取消订单或交易、暂时封停及永久查封账号的权利。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>3.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">在您使用爱学习产品和／或服务期间，爱学习有权删除不符合法律法规、部门规章、公序良俗的问答、评论、信息等，以及爱学习认为跟爱学习产品和／或服务不相关或者认为不适当、不合理的内容，包括但不限于含有色情、暴力、恐怖内容，具有广告性质，含有反动内容，含有人身攻击内容，含有违背伦理道德内容，具有恶意、无聊和灌水性质，涉及违法犯罪的内容，以及其他违反法律及爱学习平台管理制度的内容。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>3.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">对账号的管理原则</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>3.3.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span style="font-family:微软雅黑; font-weight:normal">您应保证您注册、登录并使用的账号符合中国相关法律法规的规定，符合《互联网用户账号名称管理规定》，符合本协议的各项规定。爱学习有权对您注册、登录并使用的账号名称、头像等注册信息进行审核，您应确保使用的账号名称、头像等信息中不得出现违法和不良信息，不存在以虚假信息骗取账号名称注册的情形；您应确保登录爱学习平台使用的账号名称不得为您冒用关联机构或社会名人注册的账号名称。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>3.3.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span style="font-family:微软雅黑; font-weight:normal">如果您以虚假信息骗取账号名称注册，或您的账号名称、头像等注册信息存在违法和不良信息的，爱学习有权采取通知限期改正、暂停使用、注销登记等措施；如果您冒用关联机构或社会名人注册账号名称的，爱学习有权注销您的账号，并向互联网信息内容主管部门报告。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>3.3.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span style="font-family:微软雅黑; font-weight:normal">若您存在作弊行为，发布广告，发布黄色、反动内容，发布不文明内容，抄袭、模仿管理人员I</span><span style="font-family:微软雅黑; font-weight:normal">D</span><span style="font-family:微软雅黑; font-weight:normal">，用以假冒管理人员或破坏管理人员形象，模仿或盗用他人I</span><span style="font-family:微软雅黑; font-weight:normal">D</span><span style="font-family:微软雅黑; font-weight:normal">，发布的内容包含有严重影响网友浏览的内容或格式，或者存在其他扰乱爱学习平台管理秩序的，或影响爱学习正常经营行为的，爱学习有权视情节严重程度，对您采取处罚措施（包括但不限于拒绝提供产品及服务、限制使用权限、清除或编辑内容、取消订单或交易、暂时封停及永久查封账号等）。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>3.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">投诉、举报制度</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:21pt">
        <span style="font-family:微软雅黑; font-weight:normal">如果您认为爱学习平台中的提问、回答、发言或其他信息、资料、内容等存在违反法律法规及爱学习平台相关管理规定的，涉嫌侮辱或者诽谤他人，或者侵犯您或第三方的商标权、著作权或其他合法权利情形的，您可以通过爱学习官方客服电话或爱学习客服邮箱进行举报、投诉。爱学习将在收到您的投诉后依据中国法律法规和政府规范性文件及爱学习平台管理规定采取措施进行处理。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:21pt">
        <span>&nbsp;</span>
      </p>
      <ol start="4" type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:微软雅黑; font-weight:bold;  margin:0pt 0pt 0pt 14.47pt; padding-left:6.53pt; text-indent:0pt">
          <span>用户信息</span>
        </li>
      </ol>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>4.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您应自行诚信向本站提供注册资料，您应保证您提供的资料真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新。如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且爱学习保留终止您使用爱学习产品和／或服务的权利。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>4.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您在爱学习平台进行浏览、使用等活动时，涉及您真实姓名／名称、通信地址、联系电话、电子邮箱等隐私信息的，爱学习将予以严格保密，除非得到您的授权或法律另有规定，否则爱学习不会向外界披露您的隐私信息。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>4.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>您同意，爱学习拥有通过邮件、短信、电话等形式，向您发送学习信息、推广信息及其他形式的通知、内容的权利。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <ol start="5" type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:微软雅黑; font-weight:bold;  margin:0pt 0pt 0pt 14.47pt; padding-left:6.53pt; text-indent:0pt">
          <span>不允诺担保、责任有限及免责声明</span>
        </li>
      </ol>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>不允诺担保：您在爱学习平台的提问、回答、发言仅代表您个人观点，与爱学习无关，且爱学习不对您的提问、您发表的回答或评论的正确性、准确性、真实性进行保证。爱学习仅按您提问、回答、发言现状进行展示，包含瑕疵及缺陷，爱学习不提供任何其他担保。爱学习不允诺其他无论是明示的还是默示的保证和担保，包括但不限于对特定目的的适销性和适应性，不侵权，以及任何出自交易过程或商业惯例的保证和条件。您从爱学习或他处获取的任何建议或信息，不论是口头的还是书面的，都不会对爱学习产生本协议明确约定之外的其他保证和担保责任。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>责任有限：适用法律所允许的最大范围内，不论出于何种原因，爱学习对您承担的责任及赔偿上限为您为使用爱学习的产品和／或服务而向爱学习支付的费用总额。如果爱学习免费向您提供了产品和／或服务，则爱学习无义务对您承担任何赔偿责任。任何情况下，爱学习不对出自本协议或与本协议有关的或与爱学习的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论爱学习是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>爱学习不保证（包括但不限于）：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.3.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>所提供的产品和／或服务不受干扰，及时、安全、可靠或不出现错误；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.3.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您经由本服务取得的任何产品、服务或其他材料符合您的期望。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>您使用经由本服务下载的或取得的任何信息、资料，其风险由您自行负担。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>因以下情形的发生影响本协议履行或影响爱学习提供产品及服务的，爱学习在法律允许的最大范围内免责：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.5.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>因自然灾害、罢工、暴乱、战争、重大传染病疫情、政府行为、司法行政命令等不可预见、不可避免、无法克服的不可抗力因素；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.5.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您或爱学习的计算机软件、手机软件、系统、硬件出现故障或其他原因导致您无法使用爱学习提供的产品和／或服务；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.5.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>因电力供应故障、电信运营商系统故障、通讯网络故障（包括但不限于电子通讯传达失败或延时、用于电子通讯的计算机程序对电子通讯的拦截或操纵）等公共服务因素或您自身因素（包括但不限于您操作不当、通过非爱学习授权的方式使用本服务等）或第三人因素（包括但不限于受到计算机病毒、木马入侵或其他恶意程序、黑客攻击的破坏，以及账号密码被第三方盗用等）；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.5.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>在爱学习已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、缺陷、网络信息与数据安全事件、技术风险等因素；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.5.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您知悉并理解，爱学习将最大程度履行合理的注意义务，维护数据准确性，但由于互联网技术条件限制等客观原因，系统可能会出现网页显示信息滞后或差错现象，爱学习将在发现后尽快进行修复；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>5.5.6</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>其他爱学习无法控制、无法避免及无法合理预见的情形。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <ol start="6" type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:微软雅黑; font-weight:bold;  margin:0pt 0pt 0pt 14.47pt; padding-left:6.53pt; text-indent:0pt">
          <span>知识产权</span>
        </li>
      </ol>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>6.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">除非另有说明或法律法规另有规定，爱学习拥有爱学习平台及平台包含的任何文字、图表、音频、视频或软件（包括但不限于软件中包含的图表、动画、音频、视频、界面设计、版面框架、数据和程序、代码、文档）等信息或材料的所有权及知识产权。爱学习平台及平台包含的信息或材料均受《中华人民共和国著作权法》、《中华人民共和国专利法》、《中华人民共和国商标法》及其他适用法律法规、国际条约的保护。未经爱学习书面同意，您不得删除或以其他方式改变爱学习平台及平台包含的信息或材料所附带的版权、商标或其他权利声明或标识。您不得对爱学习平台及平台包含的信息或材料进行反向工程、反向编译或反汇编，不得试图进行任何获得爱学习平台软件源代码的访问或行为，不得修改、发行、出租、出借、出售、分发、复制、信息网络传播、翻译爱学习软件，也不得创作爱学习软件的衍生品或用于商业用途。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>6.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您不得侵犯包括他人的著作权在内的知识产权以及其他权利。</span><span>一旦由于您的提问、回答、发言或其他在平台的操作行为发生法律纠纷，其责任在于您本人，与爱学习无关。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>6.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">对于您发表到爱学习平台上的任何内容，您同意爱学习在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内</span><span style="font-family:微软雅黑; font-weight:normal">容（整体或部分），和／或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。并且，您许可爱学习有权利就任何主体侵权而单独采取法律行动（包括但不限于诉讼、举报、律师函等形式）。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>6.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">当您的提问、回答或其他形式的言论、发布的内容侵犯了第三方的著作权或其他权利，第三方就此提出异议时，爱学习有权删除相关的内容，提出异议者和您之间以和解、调解、仲裁、诉讼等方式解决了相关争议后，如您要求恢复被删除内容的，您应当向爱学习提供相关的书面材料作为依据，爱学习在得到有关申请并核实无误后，将在技术条件允许的范围内尽可能恢复被删除的内容。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>6.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">就您在使用爱学习提供的产品和／或服务过程中获悉／获取的信息（包括但不限于技术信息、经营信息、管理信息、人员信息、客户信息、产品信息、服务信息、重大法律信息、价格信息等一切经爱学习采取保密措施或标注、告知为保密的信息，以及依一般观念足以认为属于爱学习商业秘密的信息，不论该等信息是以书面、口头形式抑或其他形式进行披露，也不论该等信息处于何种载体），在没有得到爱学习事先书面同意的情况下，您不得擅自披露给其他任何第三方，也不得用于本协议之外的任何目的。如您擅自披露给其他第三方，或用于本协议之外的目的（包括但不限于自行或提供给第三方利用复制、发送、传播等手段用于盈利目的），爱学习将依法追究相关当事人的法律责任。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>6.6</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>尽管有本协议6.</span><span>5</span><span>条之约定，您理解并同意，爱学习平台及爱学习工作人员（含教师）在为您提供产品和／或服务过程中发表的任何形式的言论、向您展示的任何形式的内容、向您提供的任何形式的文件或资料等，均属于爱学习商业机密，非经爱学习书面同意，您不得将上述内容的全部或部分擅自披露给其他任何第三方（包括但不限于采用口头披露、转发、分享、复制、截图等任何形式），否则，爱学习有权依法追究您的法律责任。如由此给第三方造成损失或侵犯第三方合法权益的，相关纠纷概由您负责解决，责任概由您承担。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>6.7</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">未经爱学习事先书面同意，禁止使用任何机器人、爬虫程序、其他自动设备，或手动程序等来监视或复制爱学习平台及其所包含的任何内容。否则，爱学习有权依法追究相关当事人的法律责任。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <ol start="7" type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:微软雅黑; font-weight:bold;  margin:0pt 0pt 0pt 14.47pt; padding-left:6.53pt; text-indent:0pt">
          <span>隐私保障</span>
        </li>
      </ol>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>爱学习基于向您提供产品和／或服务的目的，以及向您提供更优质、更个性化产品和／或服务的目的而收集您的信息。同时，爱学习重视未成年人的个人信息保护，如您为未成年人，请务必由您的监护人仔细阅读本隐私保障条款，并在征得监护人同意的前提下使用爱学习产品、服务或向爱学习提供您的相关信息。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>在您使用爱学习产品和／或服务的过程中，爱学习将遵循合法、正当、必要的原则，收集您使用爱学习产品和／或服务的相关信息，包括但不限于：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.2.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您注册或登录账号时提供的信息，例如您注册账号使用的电话号码、姓名等；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.2.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您主动上传的信息，例如您主动填写的信息或您与爱学习客服联系时提供的相关信息等；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.2.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>您使用爱学习产品和／或服务过程中产生的信息。爱学习会根据您授予的权限，接收并记录您所使用的设备信息、日志信息等；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.2.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>爱学习根据您授权通过合法方式收集的其他信息。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>爱学习非常重视您的信息安全，并尽最大合理努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，确保您的信息不会被泄漏、篡改、毁损或丢失，包括但不限于S</span><span>SL</span><span>、信息加密存储、数据中心的访问控制、信息访问权限控制等。且，爱学习不会非法出售、非法向他人提供您的信息。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>爱学习不会将您的个人信息提供给任何第三方，也不会用于任何其他目的和用途，但是以下情形除外：</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.4.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>经您事先同意，向第三方披露；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.4.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.4.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>爱学习与第三方合作向您提供爱学习平台的相关产品和／或服务或其他网络服务，且该等第三方同意承担与爱学习同等的保护您信息的责任；</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.4.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span><span>其他根据法律、法规或者政策应进行的披露。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>7.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span>本隐私保障条款仅为概要性规定，爱学习会发布单独的《爱学习隐私权政策》对收集、使用、存储、保护您个人信息的行为和相关内容进行详细的告知和规定，详情请查看爱学习另行发布的《爱学习隐私权政策》。如本隐私保障条款与《爱学习隐私权政策》中的告知和规定不一致的，以后者为准。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span />
      </p>
      <ol start="8" type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:微软雅黑; font-weight:bold;  margin:0pt 0pt 0pt 14.47pt; padding-left:6.53pt; text-indent:0pt">
          <span>服务条款的修改</span>
        </li>
      </ol>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:21pt">
        <span>爱学习有权在必要时修改本协议条款以及各单项服务的相关条款。您在享受单项服务时，应当及时查阅了解修改的内容，并自觉遵守本协议条款以及该单项服务的相关条款。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <ol start="9" type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:微软雅黑; font-weight:bold;  margin:0pt 0pt 0pt 14.47pt; padding-left:6.53pt; text-indent:0pt">
          <span>其他</span>
        </li>
      </ol>
      <p style=" margin:0pt 0pt 0pt 21pt; padding-left:21pt; text-indent:-21pt">
        <span>&nbsp;</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>9.1</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">如果爱学习提供的某项产品或服务附有单独的《用户服务协议》的，则该产品或服务的使用将受该单独《用户服务协议》的约束，不再受本协议约束。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>9.2</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您通过点击确认的方式接受本协议，即表示您同意接受本协议的全部约定内容。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>9.3</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">本协议的签订、生效、履行、争议的解决等任何方面均适用中华人民共和国大陆地区法律。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>9.4</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">有关本协议的争议应通过友好协商解决，如果协商不成，该争议应提交爱学习所在地有管辖权的人民法院诉讼解决。</span>
      </p>
      <p style=" margin:0pt 0pt 0pt 42pt; text-indent:-21pt">
        <span>9.5</span><span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp; </span><span style="font-family:微软雅黑; font-weight:normal">您在使用爱学习产品和／或服务过程中有任何疑问、意见、建议，或打算进行举报、投诉，可通过爱学习官方客服电话</span><a name="_Hlk78910261"><span style="font-family:微软雅黑; font-weight:normal">【</span><span>4</span><span>00</span><span>-8</span><span>98</span><span>-1</span><span>009</span><span>】</span></a><a name="_Hlk78910256"><span style="-aw-bookmark-end:_Hlk78910261" /><span>、【</span></a><a name="_Hlk78909026"><span>4</span><span>00</span><span>-</span><span>898</span><span>-</span><span>9909</span></a><span>】</span><span style="-aw-bookmark-end:_Hlk78910256" /><span style="font-family:微软雅黑; font-weight:normal">或客服邮箱</span><a name="_Hlk65601786"><span>【khfwb</span><span>@</span><span>a</span><span>ixuexi.com</span><span>】</span></a><span style="font-family:微软雅黑; font-weight:normal">与我们进行联系。</span>
      </p>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean
  },
  methods: {
    handleCancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less">
@import '~@/static/css/base.less';

.protocol-modal {
  .ant-modal-body {
    color: @gray-2!important;
    line-height: 2;
    font-size: 16px;
    font-weight: bold;
    padding: 10px 10px 40px 10px;

    .modal-body-main {
      padding: 30px 30px 0 30px;
      max-height: 80vh;
      overflow: auto;
    }

    a {
      color: @gray-2!important;
    }
  }
}
</style>